import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { userSelectors } from 'reducers';
import { useSubscriptionFormSignatureStatus } from 'utils/hooks';
import { texts } from 'utils/languages/fr';

import { SubscriptionInfo } from 'containers/investor-pages';
import PortfolioTable from './ProtfolioTable';
import { Box, Tooltip, Typography } from '@mui/material';
import { ActionButton } from 'components';
import { listingActionButtonStyle, subscriptionStatus } from 'utils/constants';

const Portfolio = () => {
    const navigate = useNavigate();
    const { subscriptions } = useSelector(userSelectors.getInternalUser);
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);
    const finishedSubscriptions = useMemo(
        () =>
            subscriptions.filter(
                s =>
                    s.subscriptionStatus === subscriptionStatus.FINISHED && s.investmentFund.visible
            ),
        [subscriptions]
    );

    const hasSignedBS = useSubscriptionFormSignatureStatus(tunnelSubscription);

    const hasOnlyDirectSubscriptions = useMemo(
        () => subscriptions.length > 0 && subscriptions.every(s => !s.distributorCompany),
        [subscriptions]
    );

    const handleNewSubscription = useCallback(() => navigate('/new-subscription'), [navigate]);

    return (
        <Box
            sx={theme => ({
                minHeight: `calc(100% - ${theme.constants.footerHeight}px)`,
                paddingTop: '60px',
                backgroundColor: theme.palette.common.white,
                paddingX: '100px',
            })}
        >
            <Typography
                sx={theme => ({
                    mb: '60px',
                    [theme.breakpoints.down('md')]: {
                        fontSize: 30,
                    },
                })}
                variant="h2"
                align="center"
            >
                {texts.MY_PORTFOLIO} {texts.AS_OF} {moment().format('D MMMM YYYY')}
            </Typography>
            {hasOnlyDirectSubscriptions && (
                <Box display="flex" justifyContent="center" marginBottom={4}>
                    <Tooltip title={texts.NEW_SUBSCRIPTION_TOOLTIP}>
                        <span>
                            <ActionButton
                                variant="outlined"
                                sx={listingActionButtonStyle}
                                onClick={handleNewSubscription}
                            >
                                {texts.NEW_SUBSCRIPTION}
                            </ActionButton>
                        </span>
                    </Tooltip>
                </Box>
            )}
            <PortfolioTable finishedSubscriptions={finishedSubscriptions} />
            {/* this is only for the ongoing subscription (status = in_progress) */}
            {hasSignedBS && (
                <Box
                    textAlign="center"
                    display="flex"
                    alignItems="center"
                    paddingY={8}
                    flexDirection="column"
                >
                    <SubscriptionInfo subscription={tunnelSubscription} />
                </Box>
            )}
        </Box>
    );
};

export default Portfolio;
